import { CellProps } from 'react-table';
import CustomIconButton from 'src/app/modules/component/custom-icon-button/CustomIconButton';
import { TableCustomCell } from 'src/app/modules/component/table/components/TableCustomCell';
import { TableCustomHeader } from 'src/app/modules/component/table/components/TableCustomHeader';
import { formatDateTime } from 'src/app/modules/utils/FormatUtils';

export const SERVICE_TEMPLATE_DEFAULT_COLUMNS = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} title="STT" className="text-center min-w-50x" />
		),
		id: 'STT',
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-center" data={props?.row?.index + 1} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Tên mẫu"
				className="text-center text-light min-w-300px"
			/>
		),
		id: 'Tên mẫu',
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-start"
					data={props?.data[props?.row?.index].name}
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Mẫu riêng của bác sĩ"
				className="text-center text-light min-w-150px"
			/>
		),
		id: 'Mẫu riêng của bác sĩ',
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-start"
					data={props?.data[props?.row?.index].tenNguoiTao}
				/>
			);
		},
	},
];

export const SERVICE_TEMPLATE_COLUMNS_ACTIONS = {
	Header: (props: any) => (
		<TableCustomHeader
			tableProps={props}
			title={'Thao tác'}
			className="text-center text-light w-80px"
		/>
	),
	id: 'actions',
	Cell: ({ row: { original }, tableOptions }: CellProps<any>) => {
		const { onActionClick } = tableOptions;

		return (
			<div className="d-flex justify-content-center">
				<CustomIconButton
					variant="delete"
					onClick={() => {
						onActionClick?.('delete', original);
					}}
					title="Xóa mẫu"
				>
					<i className="bi bi-trash3-fill text-danger"></i>
				</CustomIconButton>
			</div>
		);
	},
};

export const TREATMENT_HISTORY_COLUMNS = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} title="STT" className="text-center min-w-50x" />
		),
		id: 'STT',
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-center" data={props?.row?.index + 1} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Thông tin phiếu"
				className="text-center text-light min-w-300px"
			/>
		),
		id: 'Thông tin phiếu',
		Cell: ({ ...props }) => {
			let rowData = props?.data[props?.row?.index];
			let dateData = rowData?.prescriptionDate || rowData?.inputDate || rowData?.createdDate;
			return (
				<TableCustomCell
					className="text-start"
					data={formatDateTime(dateData)}
				/>
			);
		},
	},
];